import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/Footer/DesktopFooter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/Header/DesktopHeader.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/layouts/Header/header.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/Header/HeaderWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/Header/MobileHeader/MobileHeader.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/Newsletter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/Auth/AuthModalWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["RootStyleRegistry"] */ "/app/src/providers/RootStyleRegistry.js");
